import React from 'react';
import { makeStyles, Grid, Divider, CircularProgress } from '@material-ui/core';
import moment from 'moment';
import ActionItem from './ActionItem/ActionItem';
import { GET_ACTION_ITEMS } from '../Customers/graphql/queries';
import { useQuery } from '@apollo/client';
import { IActionItem } from '../Customers/types/types';
import useHandleAuthError from '../../utils/hooks/useHandleAuthError';

const useStyles = makeStyles(() => ({
  paper: {
    padding: '1rem'
  },
  header: {
    paddingBottom: '2rem',
    textAlign: 'right'
  },
  divider: {
    marginBottom: '1rem'
  }
}));

const DashBoard = () => {
  const { divider } = useStyles();
  const onError = useHandleAuthError();
  const { loading, data } = useQuery(GET_ACTION_ITEMS, {
    onError,
    fetchPolicy: 'no-cache'
  });

  const actionItems = data?.actionItems || [];
  const nextSevenDaysActionItems = actionItems.filter((item: IActionItem) => moment().isBefore(+item.date, 'day'));
  const todaysActionItems = actionItems.filter((item: IActionItem) => moment().isSameOrAfter(+item.date, 'day'));

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <div>
      <h1 className="my-6 text-3xl">Notifications</h1>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <h2 className="my-4 text-lg font-bold">Today</h2>
          <Divider className={divider} />
          {todaysActionItems.map((item: IActionItem, i: number) => (
            <ActionItem item={item} key={i} />
          ))}
        </Grid>
        <Grid item xs={6}>
          <h2 className="my-4 text-lg font-bold">Next 10 days</h2>
          <Divider className={divider} />
          {nextSevenDaysActionItems.map((item: IActionItem, i: number) => (
            <ActionItem item={item} key={i} />
          ))}
        </Grid>
      </Grid>
    </div>
  );
};

export default DashBoard;
